import React, { useContext, useState } from 'react';

import PropTypes from 'prop-types';

import _get from 'lodash/get';
import _isNil from 'lodash/isNil';
import _isNumber from 'lodash/isNumber';

import HelpTooltip from 'components/common/HelpTooltip';
import { FileSelection } from 'components/modules/files/components';
import { useBusinessFiles } from 'components/modules/files/hooks';
import { BusinessFilePropType } from 'components/modules/files/types/files';
import { sortItemsByList } from 'libs/array';
import { formatLabel } from 'libs/strings/strings';

import { DEFAULT_LABEL, DEFAULT_NAME, HELP_TOOLTIP_MESSAGE } from './SeoOgImage.constants';
import { SeoMetadataFieldsContext } from '../../SeoMetadata.context';

import './SeoOgImage.scss';

const propTypes = {
  image: PropTypes.oneOfType([BusinessFilePropType, PropTypes.number]),
  required: PropTypes.bool,
};

const defaultProps = {
  image: undefined,
  required: false,
};

export default function SeoOgImage({ image: imageProp, required }) {
  const { onChange: onChangeContext } = useContext(SeoMetadataFieldsContext);

  const [image, setImage] = useState(null);
  const isControlled = imageProp !== undefined;
  const finalImage = (isControlled ? imageProp : image) || '';
  const finalImageId = _isNumber(finalImage) ? finalImage : _get(finalImage, 'id', null);

  const { businessFiles } = useBusinessFiles({
    fileIds: !_isNil(finalImageId) ? [finalImageId] : [],
  });

  const files = _isNil(finalImageId) ? [] : sortItemsByList(businessFiles, [finalImageId], 'id');

  function onImageChange(newImages) {
    const newImage = _get(newImages, '[0]', null);
    const newImageId = _isNumber(newImage) ? newImage : _get(newImage, 'id', null);
    const newTarget = { value: newImageId, name: DEFAULT_NAME };

    setImage(newImage);
    onChangeContext({ target: newTarget }, newTarget);
  }

  return (
    <div className="seo-metadata seo-og-image">
      <div className="label-container">
        <label htmlFor="seo-metadata-seo-title"> {formatLabel(DEFAULT_LABEL, required)}</label>
        <HelpTooltip title={DEFAULT_LABEL} content={HELP_TOOLTIP_MESSAGE} />
      </div>
      <FileSelection
        id="seo-metadata-seo-og-image"
        files={files}
        onUpdateFiles={onImageChange}
        maxAllowedImages={1}
        editButtonText="Edit Image"
      />
    </div>
  );
}

SeoOgImage.propTypes = propTypes;
SeoOgImage.defaultProps = defaultProps;
